<template>
<div style="height: 100%;background-color:#fff;">
<div class="title">
    <strong @click="goIndex" style="cursor:pointer"><i class="el-icon-back"></i></strong>
    <span v-if="$route.query.type">编辑提成方案</span>
    <span v-else>创建提成方案</span>
</div>

<!-- 基本信息-->
<el-row>
    <el-col><div class="base-info"><span class="line" ></span> <span>基本信息</span></div></el-col>
</el-row>
<el-form 
:model="formData" :rules="rules" :ref="formData"  label-width="140px" class="demo-ruleForm">
    <el-form-item label="提成方案类型：" required >
     <el-select class="small-select" v-model="formData.planTypeDetail" @change="changeCalculateType" placeholder="请选择提成方案" >
      <el-option label="菜品价格提成" value="cpjgtc"></el-option>
      <el-option label="菜品收入提成" value="cpsrtc"></el-option>
    </el-select>
    </el-form-item>
      <el-form-item label="方案名称：" required prop="planName">
     <el-input placeholder="请选择方案名称" v-model="formData.planName"></el-input>
  </el-form-item>
  <el-form-item label="提成类型：">
    <el-col class="text-simple" @click.native="test">消费提成</el-col>
      </el-form-item>
    <el-form-item label="适用门店：" >
        <el-col class="text-simple">{{formData.merchantName}}</el-col>
  </el-form-item>
  <el-form-item label="方案有效期：">
    <el-radio v-model="formData.effectiveType" label="1">永久有效</el-radio>
  <el-radio v-model="formData.effectiveType" label="0">自定义时间</el-radio>
  </el-form-item>
  <el-form-item v-if="formData.effectiveType==0" label="自定义日期日：">
<el-date-picker class="data-range"
       value-format="yyyy-MM-dd"
      v-model="dateRange"
      type="daterange"
      range-separator="至"
      start-placeholder="开始日期"
      end-placeholder="结束日期">
    </el-date-picker>
  </el-form-item>
</el-form>
<!-- 提成信息 -->
<el-row>
    <el-col><div class="base-info"><span class="line" ></span> <span>提成信息</span></div></el-col>
</el-row>
<el-form :model="formData" label-width="140px" class="demo-ruleForm">
    <el-form-item label="提成计算方式：">
    <el-radio v-model="formData.calculateType" label="gdje" >固定金额</el-radio>
  <el-radio v-model="formData.calculateType" label="gdbl">固定比例</el-radio>
    <el-radio v-model="formData.calculateType" label="ccmkgdje" >超出门槛按固定金额
      
      </el-radio>
      <!-- <img src="../../assets/images/问号.svg" style="width: 17px;height: 24px;"> -->
      <el-radio v-model="formData.calculateType" label="ccmkgdbl" v-show="formData.planTypeDetail=='cpjgtc' ">超出门槛按固定比例</el-radio>
  </el-form-item>

        <el-form-item label="提成菜品类型：">
             <!-- <el-radio v-model="radio3" label="1">指定菜品分类</el-radio> -->
    <el-radio v-model="dishType" label="2">指定菜品</el-radio>
  </el-form-item>
  <el-form-item>
    <div style="height: 2px;background:gray"></div>
  </el-form-item>
  <!--  -->
<div style="transform:translateX(145px);margin-bottom:40px">
       <el-button @click="addType" > <strong><i class="el-icon-plus"></i></strong> 添加菜品</el-button>
  <el-button style="margin-right:10px" @click="setAllMoneyBtn"  v-if="formData.calculateType=='gdje'"><strong><i class="el-icon-s-tools"></i></strong> 批量设置提成金额</el-button>
  <el-button  style="margin-right:10px" @click="showSetRateDialog" v-if="formData.calculateType=='gdbl'"><strong><i class="el-icon-s-tools"></i></strong> 批量设置提成比例</el-button>
    <el-button style="margin-right:10px" @click="setCountAndMoney" v-if="formData.calculateType=='ccmkgdje'"><strong><i class="el-icon-s-tools"></i></strong> 批量设置提成金额</el-button>
  <el-button style="margin-right:10px" @click="showAllDialogTwo"  v-if="formData.calculateType=='ccmkgdbl'"><strong><i class="el-icon-s-tools"></i></strong> 批量设置提成比例</el-button>


  <!-- <el-button @click="deleteAllTableData"> <strong><i class="el-icon-delete"></i></strong> 全部删除</el-button> -->
  <el-popconfirm
  @confirm="deleteAllTableData"
  @onConfirm="deleteAllTableData"
  confirm-button-text='确定'
  cancel-button-text='取消'
  icon="el-icon-info"
  icon-color="#f59a23"
  title="确定删除所有菜品？"
>
  <el-button slot="reference" >全部删除</el-button>
</el-popconfirm>
<el-form :data="formData.productList" ref="formData.productList">
  <el-table
    ref="formData.productList"
    :data="formData.productList"
    height="246"
    style="width: 70%">
    <el-table-column type="index" label="序号" :key="0"></el-table-column>
    <el-table-column
    :key="1"
      prop="productName"
      label="菜品名称"
    >
    </el-table-column>
    <el-table-column
    :key="2"
      prop="formatDesc"
      label="菜品规格"
     >
    </el-table-column>
    <el-table-column
    :key="3"
      prop="saleAmount"
      label="售卖价"
      >
    </el-table-column>
    <!--  -->

        <el-table-column
        :key="4"
        v-if="formData.calculateType=='ccmkgdje' || formData.calculateType=='ccmkgdbl'"
      prop="saleNum"
      label="销售数量大于"
       width="160" 
      >
    <template slot-scope="scope">

      <el-input class="saleMoreThan" placeholder="请输入" v-model.number="scope.row.saleNum" required></el-input>
    </template>
    </el-table-column>

        <el-table-column
        :key="5"
        v-if="formData.calculateType=='gdje'"
      label="提成金额"
      >
      <template slot-scope="scope" >
             <el-input class="table-input" v-model="scope.row.royaltyAmount">
         <template slot="append">元</template>
      </el-input>
      </template>
    </el-table-column>
            <el-table-column
            :key="6"
        v-if="formData.calculateType=='gdbl' "
      label="提成比例"
      >
      <template slot-scope="scope">
              <el-input class="table-input" v-model="scope.row.royaltyRate">
         <template slot="append">%</template>
      </el-input>
      </template>
    </el-table-column>

        <el-table-column :key="7"  width="160"  v-if="formData.calculateType=='ccmkgdje'" label="超出部分每单位提成金额" prop="超出部分每单位提成金额">
          <template slot-scope="scope"  >
                  <el-input class="table-input"  v-model="scope.row.royaltyAmount" placeholder="请输入金额" >
         <template slot="append">元</template>
      </el-input>
          </template>
    </el-table-column>

            <el-table-column :key="8" width="160" v-if="formData.calculateType=='ccmkgdbl'" label="超出部分每单位提成比例" prop="超出部分每单位提成比例">
              <template slot-scope="scope">
                <el-input class="table-input"  v-model="scope.row.royaltyRate" placeholder="请输入比例">
         <template slot="append">%</template>
      </el-input>
              </template>
    </el-table-column>
    <el-table-column label="操作"
    :key="9"
    width="100"  >
      <template slot-scope="scope">
        <el-popconfirm
         @confirm="deleteTableRow(scope.$index)"
        @onConfirm="deleteTableRow(scope.$index)"
  title="确定删除该菜品吗？"
>
<span slot="reference" style="color:#f60000;cursor: pointer;">
删除
</span>
</el-popconfirm>
      </template>

    </el-table-column>
  </el-table>
</el-form>
</div>
<!-- 批量设置提成金额 -->
<el-dialog
  title="批量设置提成金额"
  :visible.sync="setMoney"
  width="30%"
  >
  <el-input v-model="setAllMoney" class="suffix-all" placeholder="请输入">
    <span slot="suffix">元</span>
  </el-input>
  <span slot="footer" class="dialog-footer">
    <el-button @click="setMoney=false">取 消</el-button>
    <el-button type="primary" @click="setMoneySubmit">确 定</el-button>
  </span>
</el-dialog>
<!-- 批量设置提成比例 -->
<el-dialog
  title="批量设置提成比例"
  :visible.sync="setRate"
  width="30%"
  >
  <el-input v-model="setAllRate" class="suffix-all" placeholder="请输入">
    <span slot="suffix">%</span>
  </el-input>
  <span slot="footer" class="dialog-footer">
    <el-button @click="setRate=false">取 消</el-button>
    <el-button type="primary" @click="setRateSubmit">确 定</el-button>
  </span>
</el-dialog>
<!-- 批量设置提成销售量和金额1 -->
<el-dialog
  title="批量设置提成金额"
  :visible.sync="setCountAndMoneyDialog"
  width="26%"
  >
  <div class="setALLDialog"><p>销售数量大于</p> <p>超出部分每单位提成金额</p></div>
  <el-input v-model="setAllMoreCount" placeholder="请输入" class="small-input-native"></el-input>
  <el-input v-model="setAllMoney" class="suffix-all small-input-native" placeholder="请输入">
    <span slot="suffix">元</span>
  </el-input>
  <span slot="footer" class="dialog-footer">
    <el-button @click="setCountAndMoneyDialog=false">取 消</el-button>
    <el-button type="primary" @click="setCountAndMoneySubmit">确 定</el-button>
  </span>
</el-dialog>
<!-- 批量设置提成销售量和金额2 -->
<el-dialog
  title="批量设置提成比例"
  :visible.sync="setCountAndMoneyDialogTwo"
  width="26%"
  >
  <div class="setALLDialog"><p>销售数量大于</p> <p>超出部分每单位提成比例</p></div>
  <el-input v-model="setAllMoreCount" placeholder="请输入" class="small-input-native"></el-input>
  <el-input v-model="setAllRate" class="suffix-all small-input-native" placeholder="请输入">
    <span slot="suffix">%</span>
  </el-input>
  <span slot="footer" class="dialog-footer">
    <el-button @click="setCountAndMoneyDialogTwo=false">取 消</el-button>
    <el-button type="primary" @click="setCountAndMoneySubmitTwo">确 定</el-button>
  </span>
</el-dialog>
<!-- <el-form-item label="不予提成菜品：">
      <el-row>
    <el-col><span style="font-size:13px;color:#f59a23">添加菜品</span></el-col>
  </el-row>
</el-form-item> -->
<el-form-item label="不予提成的业务：">
        <el-row>
        <el-checkbox v-model="formData.freeDishFlag" >赠菜</el-checkbox>
  </el-row>
</el-form-item>
</el-form>
<div class="foot">
       <el-button @click="$router.push('/commission')">取消</el-button>
    <el-button type="primary" @click="submitForm(formData)">保存并创建</el-button>
</div>
<el-dialog
  title="选择菜品"
  :visible.sync="dialogVisible"
  width="60%"
  >
  <!-- <input type="text" style="width: 95%;height: 26px;outline:none;border:1px solid #e5e5e5" placeholder="请输入搜索分类名称" v-model="dishType"> -->
    <el-input
    class="dialog-search"
    placeholder="请输入菜品名或助记码搜索"
    prefix-icon="el-icon-search"
    v-model="searchDish"
    @keyup.native="debouncedSearch"
    >
  </el-input>
  <div class="dialog-body">
    <div class="left">
      <!-- <div class="item active">全部分类</div> -->
      <div :class="{'item': true, 'active' : i==activeIndex}" v-for="item,i in categoryList" :key="i" @click="seeDetail(i,item.categoryCode)" :title="item.categoryName">{{item.categoryName}}</div>
    </div>
    <div class="right">
      <el-table
      v-loading="loadingDialog"
       @selection-change="handleSelectionChange"
      :data="tableRight"
       height="290"
      style="width: 100%">
      <el-table-column type="selection" fixed></el-table-column>
      <el-table-column
        prop="productName"
        label="菜品名称"
        align="center"
        >
      </el-table-column>
      <el-table-column
        prop="formatDesc"
         align="center"
         
        label="菜品规格"
        >
      </el-table-column>
      <el-table-column
       align="center"
        prop="normalPrice"
        label="售卖价">
      </el-table-column>
    </el-table>
    </div>
  </div>
  <span slot="footer" class="dialog-footer">
    <el-button @click="dialogVisible = false">取 消</el-button>
    <el-button type="primary" @click="showTable">确 定</el-button>
  </span>
</el-dialog>
</div>
</template>

<script>
import _debounce from 'lodash/debounce';
 export default {
    data() {
      return {
        loadingDialog:true,
        setAllMoreCount:"",//销售量大于
        setMoney:false,//批量设置金额对话框
        setAllMoney:'',//金额
        setRate:false,//批量设置提成比例对话框
        setAllRate:'',//比例
        setCountAndMoneyDialog:false,//批量设置提成金额和销售量对话框
        setCountAndMoneyDialogTwo:false,
        dialogVisible:false,//对话框
        royaltyAmount:'',//提成金额
        royaltyRate:'',//提成比例
        saleNum:'',//销售量大于
        dateRange:[],//自定义日期日
    //
        formData: {
          merchantCode:"",
          merchantName:'',
          planType:'cptc',//单前页菜品提成
          commissionType:'xftc',
          planTypeDetail: 'cpjgtc', //提成方案类型
          planName:'',//方案名称
          effectiveType:"1",//方案有效期
          startDate:"",
          endDate:'',
          calculateType:'gdje',//提成计算方式
          // dishType:'2',//指定菜品
           productList:[

           ],


          freeDishFlag:true //赠菜
        },
        dishType:'2',//指定菜品
        activeIndex:'0',//激活项
        merchantCode:"",//参数
        categoryCode:'',//初始显示第一条
        categoryList:[],//类别列表
        searchDish:'',//搜索
        tableRight:[],//右边的表格
        rules: {
          planName: [
            { required: true, message: '请输入方案名称', trigger: ['blur','change'] },
          ],
        }
      };
    },
    methods: {
      // 返回
      goIndex(){
        this.$confirm('确定退出编辑吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
         if(this.$route.query.code){
           this.$router.push('/commission?index=2')
         }else{
           this.$router.push('/commission')
         }
        }).catch(() => {
          console.log('')       
        });


        // $router.push('/commission')
      },
      //
      changeCalculateType(){
        this.formData.calculateType='gdje'
      },
      //批量设置提成比例
            setRateSubmit(){
        this.formData.productList.forEach(item=>{
          item.royaltyRate=this.setAllRate
        })
        this.setRate=false
      },
      //批量设置提成金额
      setMoneySubmit(){
        this.formData.productList.forEach(item=>{
          item.royaltyAmount=this.setAllMoney
        })
        this.setMoney=false
      },
      //批量设置提成金额和销售量
      setCountAndMoney(){
          if(this.formData.productList==null || this.formData.productList.length==0){
          this.$message.error('请先添加菜品')
          return
        }
        this.setCountAndMoneyDialog=true
      },
      //批量确定按钮1
      setCountAndMoneySubmit(){
        this.formData.productList.forEach(item=>{
          item.saleNum=this.setAllMoreCount
        })
          this.formData.productList.forEach(item=>{
          item.royaltyAmount=this.setAllMoney
        })
        this.setCountAndMoneyDialog=false
      },
      //批量确定按钮2
      setCountAndMoneySubmitTwo(){
        this.formData.productList.forEach(item=>{
          item.saleNum=this.setAllMoreCount
        })
          this.formData.productList.forEach(item=>{
          item.royaltyRate=this.setAllRate
        })
        this.setCountAndMoneyDialogTwo=false
      },
      showAllDialogTwo(){
          if(this.formData.productList==null || this.formData.productList.length==0){
          this.$message.error('请先添加菜品')
          return
        }
        this.setCountAndMoneyDialogTwo=true
      },
      //全部删除
      deleteAllTableData(){
        this.formData.productList=[]
      },
      deleteTableRow(i){
        this.formData.productList.splice(i,1)
      },
      submit(){},
      // 赋值
      showTable(){
        var arr=[]
        this.selected.forEach(item=>{
          var data={}
          data.productCode=item.productCode
          data.productName=item.productName
          data.specification=item.formatDesc
          data.saleAmount=item.normalPrice
          data.royaltyAmount=''
          data.royaltyRate=''
          data.saleNum=''
          arr.push(data)
        })
        console.log(this.formData,'赋值后')
        // this.formData.productList=this.selected
        this.formData.productList=arr
        // this.formData.productList.forEach(item=>{
        //   item.saleAmount=item.normalPrice
        // })
        console.log(this.formData.productList)
        this.dialogVisible=false
      },
      //搜索
      search(){
        if(this.searchDish==''){
          this.addType()
        }else{
          this.$http.post('/merchantProducts/queryList',{merchantCode:this.merchantCode,productName:this.searchDish}).then(res=>{
            this.tableRight=res.data.data
            this.loadingDialog=false
          })
        }
      },
      // 添加分类 查看列表
      addType(){
        this.dialogVisible=true
        this.$http.post('/merchantProductsCategory/queryList',{merchantCode:this.merchantCode}).then(res=>{
          this.categoryList=res.data.data
          this.loadingDialog=false
          this.categoryList.unshift({categoryCode: "",categoryName: "全部分类"})
          this.categoryCode=res.data.data[0].categoryCode
          this.seeDetail(0,this.categoryCode)
          
        })
      },
      // 保存并创建
      submitForm(formName) {
        //表单验证
          this.$refs[formName].validate((valid) => {
          if (valid) {
          if(this.formData.freeDishFlag==true){
          this.formData.freeDishFlag=1
        }else{
          this.formData.freeDishFlag=0
        }
        // 需要传中文名称
        if(this.formData.planTypeDetail=='cpjgtc'){
          this.formData.planDetailName='菜品价格提成'
        }else{
          this.formData.planDetailName='菜品收入提成'
        }
        //提成计算方式
        if(this.formData.calculateType=='gdje'){this.formData.calculateTypeName='固定金额'}
        else if(this.formData.calculateType=='gdbl'){this.formData.calculateTypeName='固定比例'}
        else if(this.formData.calculateType=='ccmkgdje'){this.formData.calculateTypeName='超出门槛按固定金额'}
        else{this.formData.calculateTypeName='超出门槛按固定比例'}
        if(this.formData.effectiveType==0){
          this.formData.startDate=this.dateRange[0]
          this.formData.endDate=this.dateRange[1]
        }
        console.log()
        this.$http.post('/merchantEmployeeRoyaltyPlan/add',this.formData).then(res=>{
          console.log(res)
          if(res.data.code==200){
            this.$message({message: '保存成功',type: 'success'})
            this.$router.push('/commission?index=2')
          }else{this.$message.error(res.data.message)}
        })
          } else {
           this.$message.error('请输入方案名称')
            return false;
          }
        });

      },
      resetForm(formName) {
        this.$refs[formName].resetFields();
      },
      seeDetail(i,code){
        this.activeIndex=i
        this.$http.post('/merchantProducts/queryList',{merchantCode:this.merchantCode,categoryCode:code}).then(res=>{
          this.tableRight=res.data.data
        })
      },
      handleSelectionChange(val){
        this.selected=val
      },
      setAllMoneyBtn(){
        if(this.formData.productList==null || this.formData.productList.length==0){
          this.$message.error('请先添加菜品')
          return
        }
      this.setMoney=true
      },
      showSetRateDialog(){
          if(this.formData.productList==null || this.formData.productList.length==0){
          this.$message.error('请先添加菜品')
          return
        }
        this.setRate=true
      },
      // 数据回显
      editData(){
        this.$http.post('/merchantEmployeeRoyaltyPlan/queryOne',{planType:this.$route.query.type,planCode:this.$route.query.code}).then(res=>{
          console.log(res,'数据回显')
          this.formData=res.data.data
          // 方案有效期
          if(res.data.data.effectiveType==0){
            this.dateRange[0]=res.data.data.startDate
            this.dateRange[1]=res.data.data.endDate
          }
          // 不予赠菜
          if(res.data.data.freeDishFlag==1){
            this.formData.freeDishFlag=true
          }else{
            this.formData.freeDishFlag=false
          }
          console.log(this.formData.freeDishFlag,'赠菜')
          //售卖价
          
        
        })
      }
      
    },
    created () {
      this.merchantCode=localStorage.getItem('merchantCode')
      this.formData.merchantCode=localStorage.getItem('merchantCode')
      this.formData.merchantName=localStorage.getItem('merchantName')
       this.debouncedSearch = _debounce(this.search, 500);
       console.log(this.$route.query.type ,this.$route.query.code)
       if(this.$route.query.type && this.$route.query.code){
       this.editData()
       }
    }
  }
</script>

<style  lang="less" scoped>

/deep/ .dialog-body{
  display: flex;
  margin-top: 20px;
  padding-left: 10px;
  border-bottom: 1px solid #ccc;
  .left{
    border-right: 1px solid #e8e8e8;
    padding: 12px;
    width: 22%;
    padding-top: 16px;
    height: 300px;
    overflow-y: auto;
    overflow-x: hidden;
    box-sizing: border-box;
    margin-right: 10px;
    .item{
      height: 24px;
      line-height: 24px;
      cursor: pointer;
      width: 85%;
      padding: 0 8px;
      margin-bottom: 7px;
      color: #333;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
    }
    .item:hover{
      background: rgba(246,246,246);
    }
    .item.active{
      background-color: rgba(255,189,0,.2);
    }
  }
  .right{
    // margin-left: 10px;
    width: 78%;
  }
}
.title{
    padding: 6px 10px;
    height: 36px;
    border-bottom: 2px solid #f6f6f6;
    display: flex;
    align-items: center;
    span{
        margin-left: 10px;
    }
    i,span{
      font-size: 20px;
    font-weight: 500;
    }
}
    .line {
        display: inline-block;
        width: 3px;
        height: 15px;
        background-color: orange;
        margin-right: 5px;
        border-radius: 2px;
        margin-bottom: -2px;
    }
    .base-info{
        margin: 30px 0px 10px 20px;
    }
.foot{
    display: flex;
    justify-content: right;
    height: 100px;
    background-color: #fff;
    padding-right: 60px;
}
    // /deep/ .el-form {
    //     margin:10px 0 10px 40px;
    // }
    /deep/ .el-form-item__content{
        margin-left: 5px !important;
    }
    /deep/ .el-input__inner{
        width: 100%;
    }
/deep/ .el-form-item{
    display: flex;
}
/deep/ .text-simple{
    color: #606266;
}
/deep/ .el-radio__input.is-checked .el-radio__inner{
  border-color: #f59a23;
  background-color: #f59a23;
}
/deep/ .el-radio__input.is-checked+.el-radio__label{
  color: #606266;
}
/deep/ .el-checkbox__input.is-checked .el-checkbox__inner{
    border-color: #f59a23;
  background-color: #f59a23;
}
/deep/ .el-checkbox__input.is-checked+.el-checkbox__label{
    color: #606266;
}
/deep/ .dialog-search .el-input__inner{
  width: 100%;
}
/deep/ .right .el-table-column--selection .cell{
  padding-left: 10px;
}
/deep/ .table-input input{
  width: 100%;
}
/deep/ .table-input.el-input-group{
  width: 100% !important;
}
/deep/ .saleMoreThan .el-input__inner{
  width: 100%;
}
/deep/ .data-range{
  width: 240px !important;
}
/deep/ span.el-input__suffix{
  line-height: 30px;
  margin-right: 6px;
}
/deep/ .suffix-all{
  .el-input__inner{
        width: 100%;
    }
}
.setALLDialog{
  display: flex;
  justify-content: left;
  align-items: center;
  padding-left: 8px;
  height: 40px;
  margin-bottom: 12px;
  background-color: #fafafa;
  border-bottom: 1px solid #e8e8e8;
  P{
    width: 50%;
    color: #333;
  }
}
/deep/ .small-input-native{
  width: 50%;
}


::-webkit-scrollbar {
  width: 6px; /* 调整滚动条宽度 */
}

/* 滚动条滑块样式 */
::-webkit-scrollbar-thumb {
  background-color: #CCCCCC; /* 调整滑块的背景颜色 */
  border-radius: 5px; /* 调整滑块的圆角 */
}

/* 鼠标悬停在滑块上的样式 */
::-webkit-scrollbar-thumb:hover {
  background-color: #999999; /* 调整鼠标悬停时滑块的背景颜色 */
}

/* 滚动条轨道两端的按钮样式 */
// ::-webkit-scrollbar-button {
//   background-color: #CCCCCC; 
// }

/* 滚动条轨道两端的按钮被按下时的样式 */
// ::-webkit-scrollbar-button:active {
//   background-color: #999999;
// }

/* 滚动条轨道样式 */
::-webkit-scrollbar-track {
  background-color: #F5F5F5; /* 调整轨道的背景颜色 */
}

/depp/.small-select{
  width: 200px;
}
/deep/ .el-select{
  width: 200px;
}
</style>